import {
  MDBBtn,
  MDBDatatable,
  MDBIcon,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
} from "mdb-react-ui-kit";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import HuntSupervisorBody from "./HuntSupervisorBody";
import EditWarning from "../../header/EditWarning";

function HuntSupervisors({ code, isActive, isEdited, setEdited }) {
  const { t, i18n } = useTranslation();
  const [basicActive1, setBasicActive1] = useState("tab4");
  const [basicModal, setBasicModal] = useState(false);
  const toggleShow = () => setBasicModal(!basicModal);
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);

  const handleBasicClick1 = (value) => {
    if (value === basicActive1) {
      return;
    } else if (isEdited) {
      setTargetView(value);
      setShowWarning(true);
      return;
    }
    setBasicActive1(value);
  };
  const handleOk = () => {
    setEdited(false);
    setBasicActive1(targetView);
    setShowWarning(false);
  };
  return (
    <>
      <MDBTabs>
        <MDBTabsItem>
          <MDBTabsLink
            onClick={() => handleBasicClick1("tab4")}
            active={basicActive1 === "tab4"}
          >
            {t("Members")}
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink
            onClick={() => handleBasicClick1("tab5")}
            active={basicActive1 === "tab5"}
          >
            {t("nonMembers")}
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink
            onClick={() => handleBasicClick1("tab6")}
            active={basicActive1 === "tab6"}
          >
            {t("allSupervisors")}
          </MDBTabsLink>
        </MDBTabsItem>
      </MDBTabs>
      <MDBTabsContent>
        <MDBTabsPane open={basicActive1 === "tab4"} className="p-1">
          <HuntSupervisorBody
            isActive={basicActive1 === "tab4" && isActive}
            code={code}
            supervisorFlag={1}
            setEdited={setEdited}
          />
        </MDBTabsPane>

        <MDBTabsPane open={basicActive1 === "tab5"} className="p-1">
          <HuntSupervisorBody
            isActive={basicActive1 === "tab5" && isActive}
            code={code}
            supervisorFlag={2}
            setEdited={setEdited}
          />
        </MDBTabsPane>

        <MDBTabsPane open={basicActive1 === "tab6"} className="p-1">
          <HuntSupervisorBody
            isActive={basicActive1 === "tab6" && isActive}
            code={code}
            supervisorFlag={3}
            setEdited={setEdited}
          />
        </MDBTabsPane>
      </MDBTabsContent>
      {showWarning && (
        <EditWarning
          warningToggle={warningToggle}
          setShowWarning={setShowWarning}
          onOk={handleOk}
        />
      )}
    </>
  );
}

export default HuntSupervisors;
